export default __webpack_public_path__ + "static/media/ICC - Lato.0eb71d50.svg";